import React, { useEffect, useState } from 'react'
import { useNavigate, Link, useParams } from "react-router-dom";

import axios from 'axios';
import { Helmet } from "react-helmet";

import * as CONSTANTS from '../../Constants';
import * as COMMONFUNCTIONS from '../../utils/CommonFunctions';

import Top from '../common/top';
import Header from '../common/header';
import Footer from '../common/footer';
import SEOPagesItems from '../common/faq_items';

import Error404 from '../error/404';

let rest_params = {};

function SEOPages(props)
{
    const[pageContent, setPageContent] = useState('');
    const[isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();
    const { slug } = useParams();

    const [seo, setSeo] = useState({});
    const [pageImage, setPageImage] = useState(null);
    const [apiResp, setApiResp] = useState(true);


    function getSEOPageDetails(slug)
    {
        rest_params[CONSTANTS.REST_KEY_NAME] = CONSTANTS.REST_KEY_VALUE;
        rest_params['slug'] = slug;
        try {
            axios.post(CONSTANTS.SERVER_BASE_URL+'/api/main/get_pages', rest_params, { headers : COMMONFUNCTIONS.getPostHeaders() })
            .then(responce => {
                //console.log(responce.data.plans_data);
                setApiResp(responce.data.success);
                if(responce.data.success)
                {
                    //setPayPlans(responce.data.plans_data);
                    //console.log(responce.data);
                    const seo_page_data = responce.data.plans_data;
                    setSeo(seo_page_data);
                    //setPageImage(Object.values(seo.image)[0].image);
                    setPageImage(seo_page_data.image[0].image);
                    //console.log(seo_page_data);
                }
            })
            .catch(error => {
                console.log(error);
                if(error.response !== undefined && error.response !== '' && error.response !== null)
                    COMMONFUNCTIONS.commonMessageErrorToast(error.response.data.message);
                else
                    COMMONFUNCTIONS.commonMessageErrorToast(error.message);

                setApiResp(false);

                //COMMONFUNCTIONS.RedirectToPage('404.html')
            });
        } catch(error) {
            console.log(error);
            COMMONFUNCTIONS.commonMessageErrorToast(error);
        }
        finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        const isEmpty = (obj) => obj && Object.keys(obj).length === 0 && obj.constructor === Object;
        if(slug.length > 1 && isEmpty(seo))
        {
            console.log(slug);
            getSEOPageDetails(slug);
        }
        else
        {
            console.log(slug);
            console.log(seo);
        }
    }, [seo]);

    return (
        <>
            {
                (apiResp) ? <>
                <Helmet>
                    <title>{seo.meta_title}</title>
                    <meta name="description" content={seo.meta_description} />
                    <meta name="keywords" content={seo.meta_keyword} />
                </Helmet>
        
                <div>
                    <Top/>
                    <Header/>

                    {/* REGISTER */}
                    <section>
                        <div class="login pg-faq">
                            <div class="container">
                                <div class="row">
                                    <div class="inn ab-faq-lhs">
                                        <div class="form-tit">
                                            <h1>{seo.page_title}</h1>
                                            {
                                                (pageImage !== null && pageImage !== undefined) ? <img src={CONSTANTS.SERVER_BASE_URL+"/uploads/seo_image/"+pageImage+"?x="+CONSTANTS.RANDOM_PWD} width={50+'%'} alt={seo.page_title} title={seo.page_title} className='p-t-10 m-t-40 m-b-40'/> : ''
                                            }                                       

                                            <h4><div dangerouslySetInnerHTML={{__html: seo.page_description}} /></h4>
                                        </div>
                                        {/* <SEOPagesItems /> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    {/*  END  */}
                    <Footer/>
                </div>
            </> : <Error404 />
            }
        </>
    )
}

export default SEOPages